export default "__VITE_ASSET__CrQEPn1J__"